"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvisorV2AuthError = void 0;
var AdvisorV2AuthError;
(function (AdvisorV2AuthError) {
    AdvisorV2AuthError["NO_PERSON_GUID"] = "NO_PERSON_GUID";
    AdvisorV2AuthError["NO_EXISTING_ADVISOR_LEAD"] = "NO_EXISTING_ADVISOR_LEAD";
    AdvisorV2AuthError["ADVISOR_ACCESS_NOT_ALLOWED"] = "ADVISOR_ACCESS_NOT_ALLOWED";
    AdvisorV2AuthError["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    AdvisorV2AuthError["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
})(AdvisorV2AuthError || (exports.AdvisorV2AuthError = AdvisorV2AuthError = {}));
